<template>
  <div class="parent_div">
    <form name="ecform" :action="ecsiteUrl" method="post" :accept-charset="chatset">
      <div>
        <input type="hidden" v-for="[key, val] of Object.entries(ecData)" :key="'paygent_req_' + key" :name="key" v-bind:value="val"/>
      </div>
    </form>
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import * as Check from '../../utils/Check'
import {DC_URL} from '../../constants/App'
import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'

export default {
  components: {
    'dd-header': DcHeader,
    'dd-footer': DcFooter
  },
  data () {
    return {
      orderNo: undefined,
      corpId: undefined,
      userId: undefined,
      ecData: {},
      ecsiteUrl: '',
      chatset: 'UTF-8'
    }
  },
  computed: {
  },
  methods: {
    paymentRedirect: function () {
      let payload = {
        params: {
          corpId: this.corpId,
          userId: this.userId,
          orderNo: this.orderNo
        }
      }
      axios.get(DC_URL.ORDER + '/payment-create-params', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.ecsiteUrl = response.data.data.ecsiteUrl
            this.chatset = response.data.data.charset
            let map = response.data.data
            this.$delete(map, 'ecsiteUrl')
            this.$delete(map, 'charset')
            this.ecData = map
            // 決済が返ってきたら、vuejsからformをsubmit
            this.$nextTick(function () {
              if (this.ecsiteUrl) {
                // IEはformの文字コード指定でaccept-charsetが効かない事から独自対応をする
                if (Check.isBrawserIE()) {
                  document.charset = 'SHIFT_JIS'
                }
                document.ecform.submit()
              } else {
                this.$router.push('/mmstyle/error')
              }
            })
          }
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
        })
    }
  },
  created: function () {
    this.corpId = this.$route.query.corpId
    this.userId = this.$route.query.userId
    this.orderNo = this.$route.query.orderNo
    this.paymentRedirect()
  }
}
</script>
<style src="../css/dc-mainmenu.scss" lang="scss" scoped></style>
<style src="../css/dctop4.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcRedirectPayment.vue